import React from 'react'
import { Modal, Row } from 'antd'
import VendorForm from '../../../../components/Project/Resources/Vendors/VendorsForm'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'

function VendorModal(props) {
  const { visible, modalType, submitting, submit, update, formRef, onCancel, removing, remove } = props
  return (
    <Modal
      visible={visible}
      title={'Vendor'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          remove={remove}
          removing={removing}
          submit={submit}
          update={update}
          submitting={submitting}
          title={'Department'}
          isNew={modalType === 'new'}
          isEdit={modalType !== 'new'}
        />
      }
      width={'75%'}>
      <Row>
        <VendorForm ref={formRef} {...props} />
      </Row>
    </Modal>
  )
}

VendorModal.propTypes = {}
VendorModal.defaultProps = {}

export default VendorModal
